export default __webpack_public_path__ + "static/media/invest_chart.91ee367c.svg";